import { lazy } from "react";
import { paths } from "~/router/paths";
import { app, fullscreen } from "~/helpers/routes";

const PhotoEnhancerPage = lazy(() => import("~/pages/photo-enhancer"));

export const routes: Array<any> = [
  {
    path: paths["photo-enhancer"].index,
    element: app(PhotoEnhancerPage),
  },
];
